import type { ResourceRow } from '../types';

/**
 * Find the encounter inside a registry detail payload.
 *
 * The encounter type's canonical reads are asymmetric: `list` returns
 * `PaginationResult[Encounter]` (flat rows), but `get` returns an
 * `EncounterWithAppointment` NamedTuple, which the admin route serializes via
 * `_asdict()` as `{ encounter: {...}, appointment: {...} }`.
 *
 * Registered as the encounter view's `record` normalizer, so the shell applies
 * it once and every slot — plus the schema-labelled Fields tab — sees the
 * encounter itself rather than the wrapper. Accepts either shape, so a backend
 * that later collapses the composite won't blank the view.
 *
 * Worth collapsing on the backend eventually — the composite exists because
 * the appointment join predates the registry — but that's a contract change
 * for every caller of the canonical read, not a view concern.
 */
export function encounterRecord(data: ResourceRow): ResourceRow {
  const nested = data.encounter;
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    return nested as ResourceRow;
  }
  return data;
}
